// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>
// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
// Importado antes de qualquer coisa abaixo, de propósito: imports irmãos são
// avaliados por completo, um a um, na ordem em que aparecem — então este módulo
// (que só monta o `window.createVueApp`) sempre termina de rodar antes de
// qualquer import seguinte, mesmo que um deles lance uma exceção não capturada
// durante a avaliação (Sentry maino#31356). Atribuir isso aqui mesmo, como um
// statement comum, não bastaria: statements que não são import só rodam DEPOIS que
// TODOS os imports deste arquivo terminarem de avaliar — é por isso que a atribuição
// original, no fim do arquivo, nunca rodava quando um import anterior falhava.
import './bootstrap-create-vue-app';

import { Turbo } from '@hotwired/turbo-rails'
Turbo.session.drive = false
window.Turbo = Turbo
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

import './vanila';
import './vue/shared/input-file';
import './vue/shared/multiple-select-file';
import './vue/shared/toggle-switch';
import './vue/shared/pesquisa-geral';
import './vue/shared/tour-guiado';
import '../entrypoints/widgets/main';
import '../src/plugins/driver.js';
import './vue/filtro/main';
import './vue/filtro/relatorio-main';
import './vue/filtro/relatorio-pedidos-main';
import './vue/filtro/listagem-filtros';
import './vue/filtro/botao-carregar-mais';
import '../src/js-flash/';
import "./controllers";

window.importModule=(pathComp)=>{
  import(/* @vite-ignore */ pathComp);
}
